import { render } from "./AgendaSkeleton.vue?vue&type=template&id=335aac38"
import script from "./AgendaSkeleton.vue?vue&type=script&lang=js"
export * from "./AgendaSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__